// extracted by mini-css-extract-plugin
module.exports = {"header":"business-resource-group-label_header__aIuoO","title":"business-resource-group-label_title__LxrFU"};